import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { UIProvider } from './context/UIContext';
import './index.css';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { SyncManager } from './utils/SyncManager';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <UIProvider>
                    <App />
                </UIProvider>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);

// Register Service Worker for PWA
serviceWorkerRegistration.register();

// Listen for network status to sync offline orders
window.addEventListener('online', () => {
    console.log('Online! Attempting to sync orders...');
    SyncManager.syncOrders();
});

